export default "__VITE_ASSET__DhJV89ob__"